/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ProductResultsContext } from './ProductResultsContext';
import { AppliedRefinement } from './Refinements/AppliedRefinement';
import { getClearAllWithSort, RATINGS_REFINEMENT_KEY } from '../product-results-helpers';
import '../styles/results-applied.scss';

const ResultsApplied = ({ onAppliedChange, onDisplay, onDisplayChange }) => {
  const { data, loading } = useContext(ProductResultsContext);

  if (!data) return null;

  const handleOnDisplayChange = () => {
    onDisplayChange({ useStoreFilter: 'false', multiStoreIds: [] });
  };
  const { appliedDimensions = [], searchReport, metadata } = data?.searchModel || {};

  const { totalProducts } = searchReport || {};

  const appliedRefinements = [];

  appliedDimensions.forEach((dimension) => {
    let { label, refinements } = dimension;
    if (label === 'Special Values') label = 'Price';
    refinements.forEach((refinement) => {
      let { label: refinementLabel, refinementKey } = refinement;
      if (refinementLabel === '5' && refinementKey === RATINGS_REFINEMENT_KEY) {
        refinementLabel = 'Best Rated';
      }
      appliedRefinements.push({ dimensionName: label, refinementLabel, ...refinement });
    });
  });

  if (onDisplay === 'true') {
    appliedRefinements.push({
      dimensionName: 'Get It Fast',
      refinementLabel: 'On Display',
      refinementKey: ''
    });
  }

  const handleClearAllClick = () => {
    const url = getClearAllWithSort({ metadata, searchReport });
    const refinement = {
      url,
      clear: true
    };
    if (onAppliedChange) {
      onAppliedChange({ refinement, onDisplay: 'false' });
    }
  };

  return (
    <div className="results-applied">
      {(totalProducts || totalProducts === 0) && (
        <span className="results-applied__label">{totalProducts.toLocaleString()} Results</span>
      )}
      {appliedRefinements.map((refinement, index) => {
        const { dimensionName, refinementLabel, refinementKey, url } = refinement;
        return (
          <AppliedRefinement
            key={index}
            index={index}
            deselectUrl={url}
            dimensionName={dimensionName}
            label={refinementLabel}
            refinementKey={refinementKey}
            onChange={(refinementLabel === 'On Display') ? handleOnDisplayChange : onAppliedChange}
            onDisplay={onDisplay}
          />
        );
      })}
      {appliedRefinements.length > 1 && (
        <a
          className="results-applied__clear-all"
          href="#"
          onClick={handleClearAllClick}
        >
          Clear All
        </a>
      )}
    </div>
  );
};

ResultsApplied.propTypes = {
  onAppliedChange: PropTypes.func.isRequired,
  onDisplay: PropTypes.string,
  onDisplayChange: PropTypes.func
};

ResultsApplied.defaultProps = {
  onDisplay: 'false',
  onDisplayChange: null
};

ResultsApplied.displayName = 'ResultsApplied';

export { ResultsApplied };
